<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:40:17
 -->
<!--  -->
<template>
  <div>
    <el-row :gutter="10" id="fwdt">
      <el-col :span="24">
        <div class="grid-content bg-white">
          <!-- 服务列表搜索框 -->
          <div class="row_div search_div" :span="24">
            <span :class="{active:activeClass == 1}" @click="changeFwListStatus(1)">服务列表</span>
            <span :class="{active:activeClass == 2}" @click="changeFwListStatus(2)">我的收藏</span>
          </div>
          <!-- 服务列表应用类型 -->
          <div class="yylx_div">
            <span class="color_gray">应用类型：</span>
            <span v-for="(item, index) in applicationType" :key="index" @click="changeFwdt(index, item.value)"
              class="applyType" :class="index==current ? 'active':''">{{item.label}}</span>
          </div>
          <div class="search_air">
            <span class="search_span">
              <el-input placeholder="请输入内容" class="search_input" @keyup.13="getAppName('')" v-model="fwName"></el-input>
              <i class="fa fa-search" @click="getAppName('')"></i>
            </span>
          </div>
        </div>
        <!-- 服务列表 -->
        <div style=" min-height: 300px;">
          <div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            style="width: 100%; float: left;">
            <div class="fw_list pull-left" v-for="(fwItem, index) in fwList" :key="index"
              @click="goToView(fwItem, index)">
              <img :src="fwItem.src" class="pull-left fwImg" />
              <div class="fw_content pull-left">
                <p>{{fwItem.appName}}</p>
              </div>
              <div class="deal_div">
                <span @click.stop="changeCollectionStatus(fwItem)">
                  <template v-if="fwItem.iscollect == 0">
                    <img src="/base/images/fwdt/wsc.png" alt />
                    收藏
                  </template>
                  <template v-else>
                    <img src="/base/images/fwdt/ysc.png" alt />
                    已收藏
                  </template>
                </span>
                <span>
                  <img src="/base/images/fwdt/xs.png" alt />
                  办理
                </span>
              </div>
            </div>
          </div>
          <div class="zwfw" v-show="isShow">暂无服务</div>
        </div>
      </el-col>
    </el-row>
    <!-- <div class="fwdtMenu">

          <span v-for="(item,index) in leftMenu"
                @mousemove="addActive(index)"
                @mouseout="removeActive(index)"
                :class="index==cur ? 'hoverActive':''">
              <img :src=item.activeImg alt="" class="activeImg">
              <img :src=item.normalImg alt="" class="normalImg">
              {{item.font}}
          </span>
    </div>-->
  </div>
</template>

<script>
import { RESOURSE_CONFIG } from '@/page/config/base_config'
export default {
  data() {
    return {
      loading: true,
      activeClass: 1,
      index: 1,
      fwName: '',
      tbSrc: '',
      cur: 0,
      current: 0,
      isShow: false,
      applicationType: [],
      fwList: [],
      isCollection: true,
      collectionFont: '收藏',
      leftMenu: [
        {
          activeImg: '/base/images/fwdt/wddb_active.png',
          normalImg: '/base/images/fwdt/wddb.png',
          font: '我的待办'
        },
        {
          activeImg: '/base/images/fwdt/wdxx_active.png',
          normalImg: '/base/images/fwdt/wdxx.png',
          font: '我的消息'
        }
      ]
    }
  },

  mounted() {
    setTimeout(() => {
      this.getSSFL()
    }, 1000)
    this.getAppName('')

    let that = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        that.getAppName('')
      }
    }
  },
  methods: {
    changeFwdt: function (index, val) {
      this.loading = true
      this.isShow = false
      if (val == '001') {
        val = ''
      }
      this.current = index
      this.getAppName(val)
    },
    changeFwListStatus: function (index) {
      this.loading = true
      this.isShow = false
      this.activeClass = index
      if (index == 1) {
        this.collectionFont = '收藏'
        this.isCollection = true
        this.getAppName('')
      } else {
        this.collectionFont = '已收藏'
        this.isCollection = false
        this.getAppName('')
      }
    },
    changeCollectionStatus: function (fwItem) {
      if (fwItem.iscollect == '0') {
        this.$http
          .get('/syApp/scApp', {
            params: {
              appId: fwItem.id
            }
          })
          .then(res => {
            fwItem.iscollect = '1'
          })
          .catch(error => {
            this.$message.error(error.msg)
          })
      } else {
        this.$http
          .get('/syApp/qxscApp', {
            params: {
              appId: fwItem.id
            }
          })
          .then(res => {
            fwItem.iscollect = '0'
          })
          .catch(error => {
            this.$message.error(error.msg)
          })
      }
    },

    goToView: function (row, index) {
      // this.$router.push({ name: "服务详情", query: { id: row.id } });
      // 判断打开方式， 2为新窗体打开
      if (row.dkfs == '2') {
        // 判断是否显示简介， 1跳转到服务详情页面， 直接打开url
        if (row.sfxsjj == '1') {
          let routeData = this.$router.resolve({
            name: '服务详情',
            query: { id: row.id, isCollection: row.iscollect },
            forceMenuStyle: 1
          })
          window.open(
            '#' +
            routeData.location.path +
            '?id=' +
            routeData.location.query.id,
            '_self'
          )
        } else {
          window.open(row.pcUrl, '_self')
        }
      } else {
        // 判断是否显示简介， 1跳转到服务详情页面， 直接打开url
        if (row.sfxsjj == '1') {
          this.$router.push({
            name: '服务详情',
            query: { id: row.id, isCollection: row.iscollect },
            forceMenuStyle: 1
          })
        } else {
          // 本窗口打开
          window.location.href = row.pcUrl
          // window.open(row.pcUrl)
        }
      }
    },
    addActive(index) {
      this.cur = index
    },
    removeActive(index) {
      this.cur = index
    },

    getSSFL: function () {
      this.$http
        .get('/pub/dm-const/listByCataCode', {
          params: {
            cataCode: 'APP_CLASSIFY'
          }
        })
        .then(response => {
          let result = []
          result.push({
            label: '全部',
            value: '001'
          })
          response.data.forEach(element => {
            result.push({
              label: element.label,
              value: element.value
            })
          })

          this.applicationType = result
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    getAppName: function (val) {
      let params = {}
      params.appKey = RESOURSE_CONFIG.APPLICATION_APPKEY
      params.appType = 'APP_TYPE_PC'
      let iscollect = ''
      if (this.activeClass == '2') {
        iscollect = '1'
      }
      this.fwList = []
      this.$http
        .post('/syApp/listScApp', {
          entity: {
            yyfl: 1,
            sfqy: '1', // 是否启用
            appName: this.fwName,
            ssfl: val,
            iscollect: iscollect
          },
          orderItemList: [{
            'asc': true,
            'column': 'sort'
          }]
        }, { params })
        .then(response => {
          if (response.data.length == 0) {
            this.isShow = true
            this.loading = false
          } else {
            this.isShow = false
          }
          this.fwList = []
          response.data.forEach(element => {
            if (element.iscollect == '1') {
              this.collectionFont = '已收藏'
              this.isCollection = false
            } else {
              this.collectionFont = '收藏'
              this.isCollection = true
            }
            if (element.icons == null) {
              element.src = '/base/images/index/xt_keyan.png'
              this.fwList.push(element)
              this.loading = false
            } else {
              element.src = window.config.FDFS_WEB_SERVER_URL + element.icons
              this.fwList.push(element)
              this.loading = false
              // this.$downloadFile
              //   .get("/common/document/download", {
              //     params: {
              //       fileName: "111",
              //       fileUniqueCode: element.icons,
              //       doDownload: false
              //     }
              //   })
              //   .then(res => {
              //     element.src = res.data.url;
              //     this.fwList.push(element);
              //     this.loading = false
              //   })
              //   .catch(error => {
              //     element.src = "/base/images/index/xt_keyan.png";
              //     this.fwList.push(element);
              //     this.loading = false
              //     //this.$message.error(error.msg);
              //   });
            }
          })
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    }
  }
}
</script>

<style>
.fwdtMenu {
  position: fixed;
  top: 70%;
  right: 0;
  width: 180px;
  border: 1px solid #5f93cc;
  background-color: white;
}
.fwdtMenu span {
  display: inline-block;
  width: 100%;
  float: left;
  text-align: center;
  padding: 15px 0;
  cursor: pointer;
}
.fwdtMenu span img {
  vertical-align: middle;
  margin-right: 6px;
  width: 20px;
}
.fwdtMenu .hoverActive {
  background-color: #5f93cc;
  color: white;
}
.activeImg {
  display: none;
}
.hoverActive .activeImg {
  display: inline-block;
}
.hoverActive .normalImg {
  display: none;
}
.color_gray {
  color: #999;
}
/* .theme-longyun .avue-contail,
.theme-longyun .avue-main {
  margin-top: 0 !important;
} */
</style>
<style lang='scss' scoped>
#fwdt {
  max-width: 1680px;
  width: calc(100% - 340px);
  min-width: 1280px;
  height: 100%;
  min-height: 500px;
  margin: 0 auto !important;
  :deep(.el-col) {
    padding: 0 !important;
  }
}
.text-center {
  text-align: center;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bg-white {
  background: white;
}
.deal_div {
  float: left;
  width: 100%;
  padding-left: 50px;
  margin-top: -8px;
  color: #747886;
  font-size: 12px;
  box-sizing: border-box;
}
.deal_div span {
  margin-right: 20px;
  display: inline-block;
  width: auto !important;
}
:deep(.grid-content) {
  padding: 20px;
  width: 100%;
  float: left;
  margin-bottom: 10px;
  box-sizing: border-box;
  margin-top: 15px;
}
.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}
.search_input {
  width: 300px;
}
.search_div {
  border-bottom: 1px solid #efefef;
  height: 46px;
  margin-bottom: 20px;
}
.search_air {
  position: absolute;
  right: 20px;
  top: 30px;
}
.search_span {
  position: relative;
}
.search_div span {
  font-size: 17px;
  color: #747886;
  padding-bottom: 14px;
  display: inline-block;
  margin-top: 6px;
  font-weight: bold;
  margin-right: 40px;
  cursor: pointer;
}
.search_div span.active {
  color: #0b101f;
  border-bottom: 3px solid #1871db;
}
.applyType {
  display: inline-block;
  display: inline-block;
  padding: 4px 0px;
  margin: 0 10px;
  cursor: pointer;
}
.applyType.active {
  text-decoration: none;
  background-color: #1871db;
  color: white;
  padding: 4px 12px;
  border-radius: 5px;
}
.fw_list {
  background-color: white;
  position: relative;
  float: left;
  border-right: 10px solid #f8f8f8;
  border-bottom: 10px solid #f8f8f8;
  cursor: pointer;
  height: 114px;
  border-top: 0;
  border-left: 0;
  box-sizing: border-box;
  padding: 20px;
}
.fw_list:hover {
  background-color: #dfe9f4 !important;
}
.fw_list span {
  width: 80%;
}
.fw_list span p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}
.fw_title {
  margin-bottom: 10px;
  width: 100%;
  margin-top: 0;
}
.fw_content {
  float: left;
  width: 80%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  p {
    margin: 7px 0 7px 15px;
  }
}
.initials_h4 {
  width: 100%;
  float: left;
}

.zwfw {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 20px;
  color: #ccc;
  margin-top: 100px;
}
.yylx_div {
  margin: 0 -20px;
  padding: 0 20px;
}
.fwImg {
  width: 34px;
  height: 34px;
  margin-top: 15px;
}
.fa-search {
  position: absolute;
  right: 15px;
  top: 4px;
  color: #dcdfe6;
  cursor: pointer;
}
.fw_list {
  width: 20%;
}
.fw_list:nth-child(5n + 1) {
  border-right: 0px;
}
:deep(.el-loading-spinner) {
  margin-top: 5%;
}
//     @media(max-width: 998px){
//         .fw_list {
//             width: 32.6667%;
//         }
//         .fw_list:nth-child(3n){
//             margin-right: 0px;
//         }
//     }
//     @media (min-width: 998px) and (max-width: 1200px) {
//         .fw_list {
//             width: 24.25%;
//         }
//         .fw_list:nth-child(4n){
//             margin-right: 0px;
//         }
//     }
//   @media (min-width: 1200px) and (max-width: 1400px){
//         .fw_list {
//             width: 24.25%;
//         }
//        .fw_list:nth-child(4n){
//            margin-right: 0px;
//        }
//    }
//     @media (min-width: 1400px) and (max-width: 1680px){
//         .fw_list {
//             width: 19.2%;
//         }
//         .fw_list:nth-child(5n){
//             margin-right: 0px;
//         }
//     }
//     @media (min-width: 1680px) and (max-width: 1920px) {
//      .fw_list {
//          width: 15.833333333333%;
//      }
//     .fw_list:nth-child(6n){
//       margin-right: 0px;
//     }
//    }
</style>
